// app/javascript/controllers/sidebar_controller.js
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["overlay"]

  toggle() {
    this.overlayTarget.hidden = false
    requestAnimationFrame(() => {
      this.overlayTarget.classList.remove("-translate-x-full")
    })
  }

  close() {
    this.overlayTarget.classList.add("-translate-x-full")
    setTimeout(() => {
      this.overlayTarget.hidden = true
    }, 300) // match the duration-300
  }

  stopPropagation(event) {
    event.stopPropagation() // prevent closing when clicking inside the sidebar
  }
}
